import { ConstantsBreakpoints } from '@shared/constants';

export const useAppBreakpoints = (): {
    isDesktop: ComputedRef<boolean>,
    isTablet: ComputedRef<boolean>,
    isMobile: ComputedRef<boolean>,
} => {
    // Composables
    const { width } = useWindowSize();

    // Computed
    const isDesktop: ComputedRef<boolean> = computed(() => Number(width.value) >= Number(ConstantsBreakpoints.Breakpoints.DESKTOP));
    const isTablet: ComputedRef<boolean> = computed(() => Number(width.value) >= Number(ConstantsBreakpoints.Breakpoints.TABLET));
    const isMobile: ComputedRef<boolean> = computed(() => Number(width.value) < Number(ConstantsBreakpoints.Breakpoints.TABLET));

    return {
        isDesktop,
        isTablet,
        isMobile,
    };
};
